import {
  Component,
  ViewChild,
  TemplateRef,
  ViewEncapsulation,
  ChangeDetectorRef,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { MatRowDef, MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator, MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";

import { LocationOneService } from "../location-one/location-one.service.service";
import { LocationTwoService } from "../location-two/location-two.service";
import { LocationThreeService } from "../location-three/location-three.service";
import { LocationFourService } from "../location-four/location-four.service";
import LocationOneAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/locations/location-one/location-one.entity";
import LocationTwoAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/locations/location-two/location-two.entity";
import LocationThreeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/locations/location-three/location-three.entity";

import { MatSnackBar } from "@angular/material/snack-bar";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatTooltipModule } from "@angular/material/tooltip";
import { IPaginationResult } from "app/common/interfaces/pagination-result.interface";
import { LocationFiveAttributes, LocationFourAttributes } from "@albatrosdeveloper/ave-models-package";
import { ICreateLocationFive } from "./interfaces/create-location-five.interface";
import { IUpdateLocationFive } from "./interfaces/update-location-five.interface";
import { LocationFiveService } from "./location-five.service";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: "app-location-five",
  templateUrl: "./location-five.component.html",
  styleUrls: ["./location-five.component.scss"],
  standalone: true,
  providers: [LocationTwoService],
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgSelectModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent
  ],
})
export class LocationFiveComponent implements AfterViewInit {
  displayedColumns: string[] = ["nombre", "locationOne", "locationTwo", "locationThree", "locationFour", "estado", "acciones"];
  currentCreateLocation: ICreateLocationFive = this.initializeCreateLocation();
  currentUpdateLocation: LocationFiveAttributes | undefined;

  locationOneList: LocationOneAttributes[] = [];
  locationTwoList: LocationTwoAttributes[] = [];
  locationThreeList: LocationThreeAttributes[] = [];
  locationFourList: LocationFourAttributes[] = [];

  selectedLocationOneIds: string[] = [];
  selectedLocationTwoIds: string[] = [];
  selectedLocationThreeIds: string[] = [];
  selectedLocationFourIds: string[] = [];

  filteredLocationOneList: LocationOneAttributes[] = [];
  filteredLocationTwoList: LocationTwoAttributes[] = [];
  filteredLocationThreeList: LocationThreeAttributes[] = [];
  filteredLocationFourList: LocationFourAttributes[] = [];

  dataSource: LocationFiveAttributes[] = [];
  private openSelect: any;
  searchQuery = '';
  totalItems = 0;
  pageSize = 50;
  pageIndex = 0;
  
  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  constructor(
    private readonly locationOneService: LocationOneService,
    private readonly locationTwoService: LocationTwoService,
    private readonly locationThreeService: LocationThreeService,
    private readonly locationFourService: LocationFourService,
    private readonly locationFiveService: LocationFiveService, // Nueva entidad
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
  ) { }

  ngAfterViewInit(): void {
    this.setupPaginationAndSorting();
    this.fetchAllLocations();
    this.findAllWithCount();
  }

  private initializeCreateLocation(): ICreateLocationFive {
    return { code: "", name: "", locationOneId: "", locationTwoId: "", locationThreeId: "", locationFourId: "" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount(); 
  }
  
  private fetchAllLocations(): void {
    this.fetchLocations(this.locationOneService, (res) => {
      this.locationOneList = res.data;
      this.filteredLocationOneList = [...this.locationOneList];
    });
    this.fetchLocations(this.locationTwoService, (res) => {
      this.locationTwoList = res.data;
      this.filteredLocationTwoList = [...this.locationTwoList];
    });
    this.fetchLocations(this.locationThreeService, (res) => {
      this.locationThreeList = res.data;
      this.filteredLocationThreeList = [...this.locationThreeList];
    });
    this.fetchLocations(this.locationFourService, (res) => {
      this.locationFourList = res.data;
      this.filteredLocationFourList = [...this.locationFourList];
    });
  }

  private fetchLocations(service: any, callback: (res: any) => void): void {
    service.findAll().subscribe(callback);
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";
    const locationOneCodes = this.getSelectedLocationCodes(this.selectedLocationOneIds, this.locationOneList);
    const locationTwoCodes = this.getSelectedLocationCodes(this.selectedLocationTwoIds, this.locationTwoList);
    const locationThreeCodes = this.getSelectedLocationCodes(this.selectedLocationThreeIds, this.locationThreeList);
    const locationFourCodes = this.getSelectedLocationCodes(this.selectedLocationFourIds, this.locationFourList);

    this.locationFiveService
      .findAllWithCount(
        { currentPage: pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection },
        locationOneCodes, locationTwoCodes, locationThreeCodes, locationFourCodes
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof LocationFiveAttributes {
    const validSortFields: (keyof LocationFiveAttributes)[] = ["code", "name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof LocationFiveAttributes) ? (this.sort.active as keyof LocationFiveAttributes) : "code";
  }

  private getSelectedLocationCodes(selectedIds: string[], locationList: LocationOneAttributes[] | LocationTwoAttributes[] | LocationThreeAttributes[] | LocationFourAttributes[]): string[] {
    return selectedIds.map((id) => locationList.find((loc) => loc._id.toString() === id)?.code || "");
  }

  // Métodos para manejar la selección
  onLocationOneSelectionChange(selectedIds: string[]): void {
    this.selectedLocationOneIds = selectedIds;
    this.filterLocationTwoByLocationOne();
  }

  onLocationTwoSelectionChange(selectedIds: string[]): void {
    this.selectedLocationTwoIds = selectedIds;
    this.filterLocationThreeByLocationTwo();
  }

  onLocationThreeSelectionChange(selectedIds: string[]): void {
    this.selectedLocationThreeIds = selectedIds;
    this.filterLocationFourByLocationThree();
  }

  private filterLocationTwoByLocationOne(): void {
    if (this.selectedLocationOneIds.length > 0) {
      this.filteredLocationTwoList = this.locationTwoList.filter(locationTwo =>
        this.selectedLocationOneIds.includes(locationTwo.locationOne._id.toString())
      );
    } else {
      this.filteredLocationTwoList = [...this.locationTwoList];
    }

    this.filteredLocationThreeList = [];
    this.selectedLocationTwoIds = [];
    this.selectedLocationThreeIds = [];
    this.selectedLocationFourIds = [];
  }

  private filterLocationThreeByLocationTwo(): void {
    if (this.selectedLocationTwoIds.length > 0) {
      this.filteredLocationThreeList = this.locationThreeList.filter(locationThree =>
        this.selectedLocationTwoIds.includes(locationThree.locationTwo._id.toString())
      );
    } else {
      this.filteredLocationThreeList = [...this.locationThreeList];
    }

    this.selectedLocationThreeIds = [];
    this.selectedLocationFourIds = [];
  }

  private filterLocationFourByLocationThree(): void {
    if (this.selectedLocationThreeIds.length > 0) {
      this.filteredLocationFourList = this.locationFourList.filter(locationFour =>
        this.selectedLocationThreeIds.includes(locationFour.locationThree._id.toString())
      );
    } else {
      this.filteredLocationFourList = [...this.locationFourList];
    }

    this.selectedLocationFourIds = [];
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  trackByFn(index: number, item: LocationFiveAttributes): string {
    return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  clearFilters(): void {
    this.selectedLocationOneIds = [];
    this.selectedLocationTwoIds = [];
    this.selectedLocationThreeIds = [];
    this.selectedLocationFourIds = [];
    this.searchQuery = "";
    this.filteredLocationOneList = [...this.locationOneList];
    this.filteredLocationTwoList = [...this.locationTwoList];
    this.filteredLocationThreeList = [...this.locationThreeList];
    this.filteredLocationFourList = [...this.locationFourList];
    this.findAllWithCount();
  }

  openCreateModal(): void {
    this.currentCreateLocation = this.initializeCreateLocation();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createLocation());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(location: LocationFiveAttributes): void {
    this.currentUpdateLocation = { ...location };
    this.onLocationOneSelectionChange([this.currentUpdateLocation.locationOne._id.toString()]);
    this.onLocationTwoSelectionChange([this.currentUpdateLocation.locationTwo._id.toString()]);
    this.onLocationThreeSelectionChange([this.currentUpdateLocation.locationThree._id.toString()]);
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateLocation(location._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }
  createLocation(): void {
    this.locationFiveService.create(this.currentCreateLocation).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.fetchAllLocations(); 
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateLocation(id: string): void {
    if (this.currentUpdateLocation) {
      const updatedLocation: IUpdateLocationFive = {
        locationOneId: this.currentUpdateLocation.locationOne._id.toString(),
        locationTwoId: this.currentUpdateLocation.locationTwo._id.toString(),
        locationThreeId: this.currentUpdateLocation.locationThree._id.toString(),
        locationFourId: this.currentUpdateLocation.locationFour._id.toString(),
        ...this.currentUpdateLocation
      };

      this.locationFiveService.update(id, updatedLocation).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, location: LocationFiveAttributes): void {
    const originalStatusId = location.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedLocation = { ...location, statusId: updatedStatusId };

    this.locationFiveService.update(location._id.toString(), updatedLocation).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        location.statusId = originalStatusId; // Revert to original status if the update fails
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(location: LocationFiveAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: location, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(location._id.toString()));
  }

  delete(id: string): void {
    this.locationFiveService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

}
